import { CvpLocale } from "../constants/CvpLocale";

export function validateLocale(locale: string) {
  return Object.values(CvpLocale).includes(locale as CvpLocale);
}
